module.exports = __webpack_public_path__ + "static/mogas-bb0fc95a27be13f381528a635015acec.jpg";